"use client";

import { useQueryClient } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { useGraphqlMutation } from "@/lib/graphql/useGraphql";

type UpdateMonthlySpendLimitData = {
  updateMonthlySpendLimit: string | null;
};

export type UpdateMonthlySpendLimitVariables = {
  monthly_limit_micro?: string | null;
};

const updateMonthlySpendLimitDocument = gql`
  mutation UpdateMonthlySpendLimit($monthly_limit_micro: BigInt) {
    updateMonthlySpendLimit(monthly_limit_micro: $monthly_limit_micro)
  }
`;

export const useMonthlySpendLimit = () => {
  const queryClient = useQueryClient();

  return useGraphqlMutation<UpdateMonthlySpendLimitData, UpdateMonthlySpendLimitVariables>({
    mutationKey: ["update-monthly-spend-limit"],
    document: updateMonthlySpendLimitDocument,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["billing-overview"] });
    },
  });
};
